import { useEffect, useId, useState } from 'react'
import styled from 'styled-components'
import Popover from './Popover'
import { BORDER, INK, MUTED, PrimaryButton, SecondaryButton } from './ui'
import { RAG } from 'features/dashboard/charts/scoreColour'

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/

const DatePopover = ({ anchorEl, open, onClose, onSave, value = '', title, helper, saveLabel = 'Save', fieldLabel = 'New due date' }) => {
  const inputId = useId()
  const [date, setDate] = useState(value || '')

  useEffect(() => {
    if (open) setDate(value || '')
  }, [open, value])

  const valid = DATE_RE.test(date)

  return (
    <Popover anchorEl={anchorEl} open={open} onClose={onClose} label={title} width={320} closeLabel='Close without changing the date'>
      <Title>{title}</Title>
      {helper && <Help>{helper}</Help>}
      <Label htmlFor={inputId}>{fieldLabel}</Label>
      <DateInput id={inputId} type='date' value={date} onChange={e => setDate(e.target.value)} />
      {!valid && date !== '' && <Error>Enter a full date, for example 31/12/2026.</Error>}
      <Buttons>
        <SecondaryButton type='button' onClick={onClose}>Cancel</SecondaryButton>
        <PrimaryButton type='button' disabled={!valid} onClick={() => onSave(date)}>{saveLabel}</PrimaryButton>
      </Buttons>
    </Popover>
  )
}

export default DatePopover

const Title = styled.h4`
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: ${INK};
`

const Help = styled.p`
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.45;
  color: ${MUTED};
`

const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  font-size: 15px;
  font-weight: 600;
  color: ${INK};
`

const DateInput = styled.input`
  width: 100%;
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid ${BORDER};
  border-radius: 8px;
  font: inherit;
  font-size: 15px;
  box-sizing: border-box;
`

const Error = styled.p`
  margin: 6px 0 0;
  font-size: 14px;
  color: ${RAG.critical.fg};
`

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
`
